import { NamingTypeEnum } from './naming-type.enum';

export class CompanySettingsApiModel {
  useDecimalFormatForHours = false;
  projectNamingType = NamingTypeEnum.OnlyName;
  orderNamingType = NamingTypeEnum.OnlyName;
  customerNamingType = NamingTypeEnum.OnlyName;
  dateFormat = 'dd/MM/YYYY';
}
